import { useEffect } from 'react';

import type { ActivitySection, PolylineHighlightSection } from '@strava/mre';

import { getWorldLine2FromLatLngArray } from '../../helpers/getWorldLine2FromLatLngArray';
import { useMRE } from '../../hooks/useMRE';
import { LatLng } from '../../types';

interface ActivityProps {
  id: string;
  polyline: LatLng[];
  activitySections?: ActivitySection[];
  highlights?: PolylineHighlightSection[];
}

/*
 * This component renders a single Activity on a map, e.g. Logged out ADP
 */
export const Activity = ({
  id,
  polyline,
  activitySections = [],
  highlights = []
}: ActivityProps) => {
  const { terrainEngine } = useMRE();

  useEffect(() => {
    if (!terrainEngine || !polyline || polyline.length === 0) {
      return;
    }

    // Add activity polyline
    terrainEngine
      .getContent()
      .getActivityContent()
      .displayActivity2(
        id,
        getWorldLine2FromLatLngArray(polyline),
        activitySections
      );

    // Add highlights if any
    if (highlights.length > 0) {
      terrainEngine
        .getContent()
        .getActivityContent()
        .applyActivityPolylineHighlights(id, highlights);
    }

    return () => {
      // Remove highlights if any
      if (highlights.length > 0) {
        terrainEngine
          .getContent()
          .getActivityContent()
          .clearActivityPolylineHighlights(id);
      }

      // Remove activity polyline
      terrainEngine.getContent().getActivityContent().removeActivity(id);
    };
  }, [terrainEngine, id, polyline, activitySections, highlights]);

  return null;
};
